import { useQuery } from '@tanstack/react-query';

import { fetchAssetById } from '../services/svp';

const defaultParams = { additional: 'metadata' };

export const useAssetById = (assetId?: number) => {
  return useQuery({
    queryKey: ['preset-asset-by-id', assetId],
    queryFn: () => fetchAssetById(assetId!, defaultParams),
    enabled: Boolean(assetId),
    retry: false,
  });
};
